
@if (banners.length > 0) {
  <div class="banners-container fx-col gt-sm-fx-row">
    <div class="sec-padding" class="baners fx-row xs-fx-col gt-sm-fx-col print-fx-flex-100-in-col lt-md-fx-flex-100-in-col gt-sm-fx-flex-100">
      <div class="baner first"  [ngStyle]="getBgImage(0)">
        @if (!contentLoaded) {
          <ngx-skeleton-loader loadingText="Ziplingo"
            count="1"
            [theme]="{ width: '100%', 'border-radius': '0', height: '100%' }"
          ></ngx-skeleton-loader>
        }
        @if (contentLoaded) {
          <div class="info">
            <div class="text-box">
              <h4>{{getBanner(0).title}}</h4>
              <p>{{getBanner(0).subtitle}}</p>
              <a href="#">Shop Now</a>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="fx-row xs-fx-col gt-sm-fx-col print-fx-flex-100-in-col lt-md-fx-flex-100-in-col gt-sm-fx-flex-60">
      <div class="bn-wrap fx-col gt-sm-fx-row xs-fx-flex-50-in-col print-fx-flex-50 sm-fx-flex-50 gt-sm-fx-flex-33-in-col fx-order-2 gt-sm-fx-order-1">
        <div class="baner seccond fx-flex-in-col gt-sm-fx-flex" [ngStyle]="getBgImage(1)">
          @if (!contentLoaded) {
            <ngx-skeleton-loader loadingText="Ziplingo"
              count="1"
              [theme]="{ width: '100%', 'border-radius': '0', height: '100%' }"
            ></ngx-skeleton-loader>
          }
          @if (contentLoaded) {
            <div class="info">
              <div class="text-box w-50 fx-col" >
                <h4>{{getBanner(1).title}}</h4>
                <p>{{getBanner(1).subtitle}}</p>
                <a href="#">Shop Now</a>
              </div>
            </div>
          }
        </div>
        <div class="baner seccond pd-xs fx-flex-in-col gt-sm-fx-flex" [ngStyle]="getBgImage(2)">
          @if (!contentLoaded) {
            <ngx-skeleton-loader loadingText="Ziplingo"
              count="1"
              [theme]="{ width: '100%', 'border-radius': '0', height: '100%' }"
            ></ngx-skeleton-loader>
          }
          @if (contentLoaded) {
            <div class="info">
              <div class="text-box w-50 fx-col" >
                <h4>{{getBanner(2).title}}</h4>
                <p>{{getBanner(2).subtitle}}</p>
                <a href="#">Shop Now</a>
              </div>
            </div>
          }
        </div>
      </div>
      <div class="baner seccond mg-xs-0 xs-fx-flex-50-in-col print-fx-flex-50 sm-fx-flex-50 gt-sm-fx-flex-100-in-col fx-order-1 gt-sm-fx-order-2" [ngStyle]="getBgImage(3)">
        @if (!contentLoaded) {
          <ngx-skeleton-loader loadingText="Ziplingo"
            count="1"
            [theme]="{ width: '100%', 'border-radius': '0', height: '100%'}"
          ></ngx-skeleton-loader>
        }
        @if (contentLoaded) {
          <div class="info">
            <div class="text-box w-50 pt-40 fx-col" >
              <h4 class="big-title">{{getBanner(3).title}}</h4>
              <p>{{getBanner(3).subtitle}}</p>
              <a mat-raised-button color="primary" class="big-price">$66.99</a>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

